export default __webpack_public_path__ + "static/media/GLM25000-450mg.83395f65.jpg";